import React from 'react';
import './faqs.scss';
import Accordion from 'react-bootstrap/Accordion';

const Faqschatandrepay = () => {
  const faqData = [
    {
      question: "How can I send and receive payments via Chat?",
      answer:
        "The TOMI app combines secure messaging with instant payments, allowing users to send money within conversations seamlessly. Open the chat with your contact, then click the $ button to access Send/Request Payment options.",
    },
    {
      question: "Do I need to link my bank account to use the payment feature?",
      answer:
        "No, the app utilizes decentralized crypto transactions, so linking a traditional bank account is unnecessary.",
    },
    {
      question: "Can I send or request funds within group chats?",
      answer:
        "Yes! You can easily split payments or collect contributions within group chats, making shared expenses effortless.",
    },
    {
      question: "How is TOMI different from other payment apps?",
      answer:
        "Unlike traditional payment apps, TOMI integrates messaging and blockchain-based transactions in a single, secure, decentralized environment.",
    },
    {
      question: "Can I see a history of my transactions?",
      answer:
        "Yes, your full transaction history is available directly within the app for easy tracking and reference.",
    },
    {
      question: "Does TOMI support different currencies?",
      answer: "Absolutely! The app supports multiple cryptocurrencies.",
    },
  ];

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map((faq) => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer,
      },
    })),
  };

  return (
    <section className="faqsmainprnt">
      <div className="postionfaqs">
        <img className="img-fluid" src="/assets/faqpositionimg.png" alt="FAQ Section" />
      </div>
      <div className="custom-container">
        <div className="faqschldmain">
          <h2>FAQ</h2>
          <div className="faqscustumdesigine">
            <div className="accordion" id="accordionExample">
              {faqData.map((faq, index) => (
                <div className="accordion-item" key={index}>
                  <h3 className="accordion-header">
                    <button
                      className={`accordion-button ${index !== 0 ? "collapsed" : ""}`}
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`#collapse${index}`}
                      aria-expanded={index === 0 ? "true" : "false"}
                      aria-controls={`collapse${index}`}
                    >
                      <div className="btninner">{faq.question}</div>
                    </button>
                  </h3>
                  <div
                    id={`collapse${index}`}
                    className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      <div className="bodymain"><span>{faq.answer}</span></div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
    </section>
  );
};

export default Faqschatandrepay;
